module.exports = __webpack_public_path__ + "static/hyperv_6.8038671d.png";